import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "login"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = {
    key: 0,
    class: "err"
};
const _hoisted_6 = { class: "f_pass w60" };
const _hoisted_7 = {
    key: 0,
    class: "err"
};
import { watch } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import InertiaUtil from '@util/InertiaUtil';
export default /*@__PURE__*/ _defineComponent({
    __name: 'login',
    props: {
        common: {},
        errors: {}
    },
    setup(__props) {
        const props = __props;
        const form = InertiaUtil.getForm({
            email: '',
            password: '',
        });
        // 文字数チェック
        watch(() => form.email, (value) => {
            if (Alert.charLimitText(value)) {
                form.email = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.password, (value) => {
            if (Alert.charLimitText(value)) {
                form.password = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        const onSubmit = () => {
            InertiaUtil.post(form, route('login.store'));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[7] || (_cache[7] = _createElementVNode("h2", null, "ログイン", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onSubmit, ["prevent"])
                                }, [
                                    _createElementVNode("dl", null, [
                                        _cache[3] || (_cache[3] = _createElementVNode("dt", null, "メール", -1)),
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).email) = $event)),
                                                type: "email",
                                                name: "f_mail",
                                                class: "wmax",
                                                autocomplete: "on"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).email]
                                            ]),
                                            (props.errors.email)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(props.errors.email), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _cache[4] || (_cache[4] = _createElementVNode("dt", null, "パスワード", -1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).password) = $event)),
                                                    class: "wmax",
                                                    type: "password",
                                                    id: "textPassword_1",
                                                    autocomplete: "on"
                                                }, null, 512), [
                                                    [_vModelText, _unref(form).password]
                                                ]),
                                                _cache[2] || (_cache[2] = _createElementVNode("span", {
                                                    id: "buttonEye_1",
                                                    class: "fa fa-eye",
                                                    onclick: "pushHideButton(1)"
                                                }, null, -1))
                                            ]),
                                            (props.errors.password)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(props.errors.password), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "bt_box" }, [
                                        _createElementVNode("button", {
                                            type: "submit",
                                            id: "submit-button",
                                            class: "b_max"
                                        }, "ログイン")
                                    ], -1))
                                ], 32)
                            ]),
                            _createVNode(_unref(Link), {
                                class: "normal",
                                href: "/forgot-password"
                            }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createTextVNode("パスワードをお忘れの方はこちら")
                                ])),
                                _: 1,
                                __: [6]
                            })
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
